module.exports = __webpack_public_path__ + "img/darkMode.f5306d6c.svg";